<template>
    <div name="">
        <img style="width: 100%" :src="url" />
    </div>
</template>

<script>
export default {
    name:'calculateSaveFileView',
    data: function()
    {
        return {
            code: null,
            url: ''
        }
    },
    mounted: function()
    {
        this.code = this.$route.query.code;
        if(this.code === null || this.code === undefined || this.code === '')
        {   
            alert("잘못된경로입니다.")
            this.$route.push({path: '/calc'})
        }

        this.url = `https://d3mz0r05sqimo9.cloudfront.net/calculator/${this.code}`
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/page/CalculateSaveFileView.vue